var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie-chart-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.6753 13.8955C17.1452 15.1492 16.316 16.254 15.2602 17.1133C14.2045 17.9725 12.9543 18.56 11.619 18.8245C10.2838 19.089 8.90402 19.0223 7.60046 18.6303C6.29689 18.2384 5.10919 17.5331 4.14119 16.5761C3.17318 15.619 2.45435 14.4395 2.04753 13.1405C1.64072 11.8415 1.5583 10.4626 1.8075 9.12437C2.0567 7.78616 2.62992 6.52937 3.47704 5.46387C4.32417 4.39837 5.4194 3.55661 6.667 3.01218M17.6993 7.46482C18.0329 8.2702 18.2376 9.12165 18.307 9.98788C18.3242 10.2019 18.3328 10.3089 18.2903 10.4053C18.2548 10.4858 18.1844 10.562 18.107 10.6038C18.0143 10.6538 17.8986 10.6538 17.667 10.6538H10.667C10.4336 10.6538 10.317 10.6538 10.2278 10.6084C10.1494 10.5685 10.0857 10.5047 10.0457 10.4263C10.0003 10.3372 10.0003 10.2205 10.0003 9.98718V2.98718C10.0003 2.75562 10.0003 2.63985 10.0504 2.54716C10.0922 2.46975 10.1684 2.39942 10.2489 2.36392C10.3453 2.32143 10.4523 2.33001 10.6663 2.34717C11.5325 2.41661 12.384 2.62125 13.1894 2.95485C14.2004 3.37364 15.1191 3.98747 15.8929 4.76129C16.6667 5.53511 17.2805 6.45377 17.6993 7.46482Z",
    stroke: "#676A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightDefault);
export default __webpack_public_path__ + "static/media/insightDefault.f7a7aab393165f87efc0ded47ec1f5a0.svg";
export { ForwardRef as ReactComponent };